import { BackendResource, Compatibility } from "../../models/SmartHomeApi";
import { slice } from "./reducer";
import * as selectors from "./selector";

export interface DeviceCompatibilityState {
  propertyId?: string;
  isLoading: boolean;
  error?: string;
  data?: BackendResource<Compatibility>[];
}

export const DeviceCompatibilityStore = {
  reducer: slice.reducer,
  actions: slice.actions,
  selectors,
};
